import { ArrowUpDown } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const SORT_OPTIONS = [
  { id: "popular", label: "Popular" },
  { id: "newest", label: "Newest" },
  { id: "price_asc", label: "Price: Low to High" },
  { id: "price_desc", label: "Price: High to Low" },
  { id: "reviews", label: "Reviews: Good to Bad" },
];

export const MarketSort = ({ value, onChange }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid="market-sort-trigger" aria-label="Sort by"
      className="h-8 w-auto gap-1.5 rounded-full bg-[#1E1E1E] border-[#27272A] text-xs text-[#D1D5DB] px-3 focus:ring-0 focus:border-[#3B82F6]">
      <ArrowUpDown className="h-3.5 w-3.5 text-[#6B7280]" />
      <span className="text-[#6B7280]">Sort:</span>
      <SelectValue />
    </SelectTrigger>
    <SelectContent className="bg-[#121212] border-[#27272A] text-[#F3F4F6]">
      {SORT_OPTIONS.map((o) => (
        <SelectItem key={o.id} value={o.id} data-testid={`market-sort-${o.id}`} className="text-xs focus:bg-[#1E1E1E] focus:text-white">
          {o.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
